import { useState, ChangeEvent } from "react";

interface PersonalInfoData {
  firstName?: string;
  lastName?: string;
  email?: string;
  phoneNumber?: string | null;
  birthLastName?: string;
}

export const usePersonalInfo = (initialData?: PersonalInfoData) => {
  const [firstName, setFirstName] = useState<string>(
    initialData?.firstName || "",
  );
  const [lastName, setLastName] = useState<string>(initialData?.lastName || "");
  const [email, setEmail] = useState<string>(initialData?.email || "");
  const [phoneNumber, setPhoneNumber] = useState<string | null>(
    initialData?.phoneNumber || null,
  );
  const [birthLastName, setBirthLastName] = useState<string>(
    initialData?.birthLastName || "",
  );

  const handlers = {
    onFirstNameChange: (event: ChangeEvent<HTMLInputElement>) =>
      setFirstName(event.target.value),
    onLastNameChange: (event: ChangeEvent<HTMLInputElement>) =>
      setLastName(event.target.value),
    onEmailChange: (event: ChangeEvent<HTMLInputElement>) =>
      setEmail(event.target.value),
    onPhoneNumberChange: (event: ChangeEvent<HTMLInputElement>) =>
      setPhoneNumber(event.target.value),
    onBirthLastNameChange: (event: ChangeEvent<HTMLInputElement>) =>
      setBirthLastName(event.target.value),
  };

  return {
    values: { firstName, lastName, email, phoneNumber, birthLastName },
    handlers,
    setters: {
      setFirstName,
      setLastName,
      setEmail,
      setPhoneNumber,
      setBirthLastName,
    },
  };
};
